import { candidatesQueryKeys } from "./query-keys";

import type { AsyncFilterOptions } from "@/components/ui/v2/filters/FiltersDrawer";
import type { UseApplyFiltersParams } from "@/features/integrations/modules/applies/api";
import { useFilterOptionsInfinite } from "@/features/integrations/shared/api/useFilterOptionsInfinite";

/**
 * One dimension of the Candidates filter drawer, paged on scroll and searched server-side. Same
 * dimensions as the Applies drawer, but each count is the number of distinct candidates the option
 * would leave, so the numbers match the rows of this table (OR-2155).
 */
export function useCandidateFilterOptions(
  dimension: string,
  params: UseApplyFiltersParams,
  optionSearch: string,
  enabled: boolean,
): AsyncFilterOptions {
  const withSearch = { ...params, optionSearch: optionSearch || undefined };

  return useFilterOptionsInfinite(
    "/api/v2/Candidates/FilterCounts",
    candidatesQueryKeys.filterOptions(dimension, withSearch),
    dimension,
    withSearch,
    enabled,
  );
}
